// Add this to a new JavaScript file or in theme.js

document.addEventListener('DOMContentLoaded', function() {
  // Animate products on scroll
  const productCards = document.querySelectorAll('.card-wrapper');
  
  // Initial check for cards in viewport
  checkCardsInViewport();
  
  // Check on scroll
  window.addEventListener('scroll', function() {
    checkCardsInViewport();
  });
  
  function checkCardsInViewport() {
    productCards.forEach(function(card) {
      if (isElementInViewport(card) && !card.classList.contains('animated')) {
        // Stagger the animation slightly for each card
        setTimeout(function() {
          card.classList.add('animated');
        }, Math.random() * 300);
      }
    });
  }
  
  function isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
      rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.bottom >= 0
    );
  }
  

});